// import { zonedTimeToUtc, utcToZonedTime, format } from "date-fns-tz";
import { zonedTimeToUtc, utcToZonedTime } from "date-fns-tz";
import { fromUnixTime, parseISO } from "date-fns";
import { fr, enUS } from "date-fns/locale";

// Maps the current i18n language to a date-fns locale so dates/months render in
// the selected UI language instead of being hardcoded to French.
export const getDateFnsLocale = (language) =>
  language && language.toLowerCase().startsWith("fr") ? fr : enUS;

export const transformFromUTC = (utc_timestamp, display_timezone) => {
  // Convert Unix timestamp to Date object (handle milliseconds)
  const ts = utc_timestamp > 1e12 ? utc_timestamp / 1000 : utc_timestamp;
  const utcDate = fromUnixTime(ts);

  // Convert UTC to target timezone
  const res = utcToZonedTime(utcDate, display_timezone);

  return res;
};

export const transformFromUTCFromISO = (utc_timestamp, display_timezone) => {
  // Convert Unix timestamp to Date object
  const utcDate = parseISO(utc_timestamp);

  // Convert UTC to target timezone
  const res = utcToZonedTime(utcDate, display_timezone);

  return res;
};

export const transformToUTC = (timestamp, display_timezone = "Europe/Paris") => {
  // If timestamp is a string, parse it to a Date object
  const localDate = typeof timestamp === "string" ? parseISO(timestamp) : timestamp;

  // Convert from source timezone to UTC
  return zonedTimeToUtc(localDate, display_timezone);
};
